import { useState } from 'react';
import { Widget } from '@typeform/embed-react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Row,
    Col,
} from 'reactstrap';
import { Icon } from '../components/icon/Icon';

const EmbeddedTypeform = () => {
    const { formId } = useParams();

    const [modalVisibility, setModalVisibility] = useState(false);

    const submitAndRedirect = (e) => {
        window.location.href = '/results/' + formId + '/' + e.responseId;
    };
    return (
        <div style={{ backgroundColor: 'black' }}>
            <Widget
                id={formId}
                style={{
                    width: '100%',
                    height: '100vh',
                    overflow: 'hidden',
                    backgroundColor: 'black',
                }}
                className="my-form"
                onSubmit={submitAndRedirect}
            />
            <Modal
                isOpen={modalVisibility}
                toggle={() => setModalVisibility(!modalVisibility)}
            >
                <ModalHeader
                    toggle={() => setModalVisibility(!modalVisibility)}
                    close={
                        <button
                            className="close"
                            onClick={() => setModalVisibility(!modalVisibility)}
                        >
                            <Icon name="x" iconType="fa" size="sm" />
                        </button>
                    }
                >
                    <h6>Privacy Policy</h6>
                </ModalHeader>
                <ModalBody>
                    <small>
                        By filling out this survey, you agree that we will
                        process your data in accordance with our{' '}
                        <a
                            href="https://www.texpertai.co.uk/privacypolicy"
                            target="_blank"
                            rel="noreferrer"
                        >
                            privacy policy
                        </a>
                        . If you have any questions or wish to delete your
                        contact details from our database please{' '}
                        <a
                            href="mailto:info@texpertai.co.uk"
                            target="_blank"
                            rel="noreferrer"
                        >
                            contact us
                        </a>
                        .
                        <br />
                        <br />
                        Note: We <strong>do not</strong> ask for your company name hence do not
                        publish results on company-level. We may send you more
                        material as we develop surveys but we never spam or sell
                        e-mails.
                    </small>
                </ModalBody>
                <ModalFooter className="bg-light">
                    <a
                        href="#close"
                        onClick={(ev) => {
                            ev.preventDefault();
                            setModalVisibility(!modalVisibility);
                        }}
                        className="p-2 link"
                    >
                        Okay
                    </a>
                </ModalFooter>
            </Modal>
            <Container>
                <Row className="justify-content-center">
                    <Col xs="12">
                        <p style={{ textAlign: 'center' }}>
                            <small>
                                <a
                                    href="#privacy"
                                    onClick={() => setModalVisibility(true)}
                                >
                                    Privacy Policy
                                </a>
                            </small>
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default EmbeddedTypeform;
